<script>
    
import axios from 'axios';
import { Modal } from "bootstrap"; // Import Bootstrap's modal

export default {
    inject: ["getList"],
    data() {
        return {
            UrlTemplate:'',
        };
    },
    methods: {
        triggerGetList() {
            this.$emit("refresh-list"); // Calls the parent function
        },
        submitFile(e)
        {                                  
            e.preventDefault();

            this.loadingUpload=true;
            let formData = new FormData();
            formData.append('file', this.sourceFile);
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL +'repayments/callogs',formData)
            .then(() => {
                this.closeModal(); 
                alert('Call Log uploaded successfully');
                setTimeout(() => {
                    this.triggerGetList(); // Call after 3s
                }, 3000);
            })
            .catch(error => {
                if(error.response?.data != undefined){
                    alert(error.response.data.message);
                }else{
                    console.log(error);
                    alert('Something when wrong! Please try again.');
                }

            })
            .finally(() => {
                this.loadingUpload=false;
            });
        },

        closeModal() {
            const modalElement = document.querySelector(".bs-example-modal-lg");
            if (modalElement) {
                const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
                modalInstance.hide(); // Close the modal
            }
            },

        handleFileUpload(event){
            this.sourceFile = event.target.files[0];
        },

        getTemplateUrl() {
            this.UrlTemplate = process.env.VUE_APP_AR_API_BASEURL.replace('api/', '')+"template/call log Template.xlsx";
        },
    },
    mounted() {
        this.getTemplateUrl();
    },
};
</script>

<template>
    
    <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myLargeModalLabel">Exclude P2P Customers (excel file)</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                
                                <form @submit="submitFile">
                                    <div class="row g-3">
                                        <div class="col-xl-6">                  
                                            <input class="form-control" type="file" v-on:change="handleFileUpload" 
                                            ref="uploadInput" accept=".xlsx, .xls, .csv" required>
                                            <div>
                                                Download the template : <a :href='UrlTemplate' target="_blank">Exclude P2P Customers</a>
                                            </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xl-6">
                                            <div class="row g-6">
                                                <div class="col-sm-4">
                                                    <div v-if="loadingUpload" class="spinner-border text-success" role="status">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                    <button v-if="!loadingUpload" type="submit" class="btn btn-success w-100" :disabled="loadingUpload">
                                                        <i class="ri-equalizer-fill me-2 align-bottom"></i>Upload
                                                    </button>
                                                    
                                                </div>

                                                <div class="col-sm-8">
                                                    
                                                </div>
                                                <!--end col-->
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                
                                
                            </div>
                            
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>